import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/primeiroAcesso';

class PrimeiroAcessoService {
    constructor() {
        this.idContribuinte = null;
        this.idCliente =null
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    enviarEmailsPrimeiroAcesso(){
        return axios.get(API_URL + '/', {headers: this.headers});
    }
    
}

export default new PrimeiroAcessoService();